import { useState } from 'react'

import { EllipsisVerticalIcon } from 'lucide-react'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'twyne-new.ui'

import SelectTemplate from './SelectTemplate'

export default function TypeActions({ setIsEditing, onRemove, onAdd }) {
  const [open, setOpen] = useState(false)

  return <>
    <DropdownMenu>
      <DropdownMenuTrigger>
        <EllipsisVerticalIcon size={16} />
      </DropdownMenuTrigger>
      <DropdownMenuContent align='start' className='p-2' container='#theme-provider'>
        <DropdownMenuItem onClick={() => onAdd()}>
          New Template
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setOpen(true)}>
          Select Template
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setIsEditing(true)}>
          Rename
        </DropdownMenuItem>
        <DropdownMenuItem>
          Duplicate
        </DropdownMenuItem>
        <DropdownMenuItem className='twy-text-danger' onClick={onRemove}>
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
    <SelectTemplate open={open} onClose={() => setOpen(false)} onAddTemplate={onAdd} />
  </>
}
